import imageCompression from "browser-image-compression";
import { getCurrentUserRole, opsTeamMember, ROLES_NAME } from "modules/utilities/utility";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";

export const orderCancellationRemark = [
	{value:'CANNOT BE TREATED', label:'CANNOT BE TREATED'},
	{value:'COURIER DELIVERY CHALLENGE', label:'COURIER DELIVERY CHALLENGE'},
	{value:'CUSTOMER NOT AVAILABLE TO ACCEPT', label:'CUSTOMER NOT AVAILABLE TO ACCEPT'},
	{value:'CUSTOMER NOT RESPONDING', label:'CUSTOMER NOT RESPONDING'},
	{value:'CUSTOMER NOT CONTACTABLE', label:'CUSTOMER NOT CONTACTABLE'},
	{value:'DISCOUNT CODE/PAYMENT MODE', label:'DISCOUNT CODE/PAYMENT MODE'},
	{value:'EXTRA MEDS', label:'EXTRA MEDS'},
	{value:'FINANCIAL ISSUE', label:'FINANCIAL ISSUE'},
	{value:'MANIFESTED NOT PICKED UP', label:'MANIFESTED NOT PICKED UP'},
	{value:'NO SCALPIE/FORM', label:'NO SCALPIE/FORM'},
	{value:'ORDER TO BE EDITED', label:'ORDER TO BE EDITED'},
	{value:'PLACED 2 ORDERS', label:'PLACED 2 ORDERS'},
	{value:'PIN CODE NOT SERVICEABLE', label:'PIN CODE NOT SERVICEABLE'},
	{value:'SPAM ORDER', label:'SPAM ORDER'},
	{value:'TEST ORDER', label:'TEST ORDER'},
	{value:'WRONG ORDER PLACED', label:'WRONG ORDER PLACED'},
]


export const subCategoryOptions = {
	order_related: [
		{ label: "Address or Phone Change", value: "edit_order" },
		{ label: "Damaged Product", value: "damaged_product" },
		{ label: "Missing Product", value: "missing_product" },
		{ label: "Mismatch Product", value: "mismatch_product" },
		{ label: "Order Cancellation", value: "order_cancellation" },
		{ label: "Reattempt Request", value: "reattempt_product" },
		{ label: "Return Product", value: "return_product" },
		{ label: "Reverse Pick up", value: "reverse_pick_up" },
	],
	medical_escalations: [
		{ label: "Hairfall", value: "hairfall_issue" },
		{ label: "Constipation", value: "constipation_issue" },
		{ label: "Dandruff", value: "dandruff_issue" },
		{ label: "Health conditions", value: "health_issue" },
		{ label: "Boils", value: "boils_issue" },
		{ label: "Itching", value: "itching_issue" },
		{ label: "Product Reaction", value: "product_reaction_issue" },
		{ label: "Sexual issue", value: "sexual_issue" },
		{ label: "Gastric issues", value: "gastric_issue" },
		{ label: "Other", value: "other_issue" },
	],
	payments: [
		{ label: "Order Related Refunds", value: "order_related_refunds" },
		{ label: "Payments Issue", value: "payments_issue" },
		{ label: "Payment failures/ No order placed", value: "payment_failure" },
		{ label: "Referral Code", value: "referral_code"}
	],
	customer_complaints: [
		{ label: "5 Months Money Back", value: "five_month_money_back" },
		{ label: "Coach Service", value: "coach_service" },
		{ label: "Angry Customer", value: "angry_customer" },
		{ label: "No Results with Traya", value: "no_results_traya" },
		{ label: "Negative Review", value: "negative_review" },
		{ label: "Slot completely missed", value: "slot_missed" },
		{ label: "Slot not catered on time", value: "slot_not_catered" },
		{ label: "Others Issue", value: "customer_others" },
	],
	tech_bugs: [
		{ label: "Order Sync", value: "order_sync" },
		{ label: "App Issue", value: "app_issue" },
		{ label: "Edit Profile", value: "edit_profile" },
		{ label: "Login Issues On Website", value: "login_issues_website" },
	],
	international_prescription: [
		{
			label: "International Prescription Request",
			value: "international_prescription_request",
		},
	],
	delivery_Issues: [
		{label: "Reattempt Request", value: "reattempt_request"},
		{label: "Initiate RTO", value: "initiate_rto"},
		{label: "Tracking link not updated", value: "tracking_link_Not_updated"},
		{label: "Incorrect Tracking Status", value: "wrong_tracking_status"},
		{label: "Amount Paid - Order not handed over", value: "amount_paid_no_order"},
	],
	other_category: [{ label: "Other Issues", value: "other_subcategory" }],
	delivery_related: [
		{ label: "Delivery Issues", value: "delivery_issues" },
		{ label: "Damaged Product", value: "damaged_product" },
	],
	prescription_related: [
		{ label: "Prescription Request", value: "prescription_request" },
	],
	escalation: [
		{
			label: "Client Escalation via Medrep call",
			value: "client_escalation_via_medrep_call",
		},
		{
			label: "Client Escalation via WABA",
			value: "client_escalation_via_waba",
		},
	],
	ivr_requests: [{ label: "Client Call missed", value: "client_call_missed" }],
};

export const subCategoryOptionsCreateTicket = {
	order_related: [
		// { label: "Address or Phone Change", value: "edit_order" },
		{ label: "Damaged Product", value: "damaged_product" },
		{ label: "Missing Product", value: "missing_product" },
		{ label: "Mismatch Product", value: "mismatch_product" },
		{ label: "Order Cancellation", value: "order_cancellation" },
		// { label: "Reattempt Request", value: "reattempt_product" },
		// { label: "Return Product", value: "return_product" },
		{ label: "Reverse Pick up", value: "reverse_pick_up" },
	],
	medical_escalations: [
		{ label: "Hairfall", value: "hairfall_issue" },
		{ label: "Constipation", value: "constipation_issue" },
		{ label: "Dandruff", value: "dandruff_issue" },
		{ label: "Health conditions", value: "health_issue" },
		{ label: "Boils", value: "boils_issue" },
		{ label: "Itching", value: "itching_issue" },
		{ label: "Product Reaction", value: "product_reaction_issue" },
		{ label: "Sexual issue", value: "sexual_issue" },
		{ label: "Gastric issues", value: "gastric_issue" },
		{ label: "Other", value: "other_issue" },
	],
	payments: [
		{ label: "Order Related Refunds", value: "order_related_refunds" },
		{ label: "Payments Issue", value: "payments_issue" },
		{ label: "Payment failures/ No order placed", value: "payment_failure" },
		{ label: "Referral Code", value: "referral_code"}

	],
	customer_complaints: [
		{ label: "5 Months Money Back", value: "five_month_money_back" },
		{ label: "Coach Service", value: "coach_service" },
		{ label: "Angry Customer", value: "angry_customer" },
		{ label: "No Results with Traya", value: "no_results_traya" },
		{ label: "Negative Review", value: "negative_review" },
		{ label: "Slot completely missed", value: "slot_missed" },
		{ label: "Slot not catered on time", value: "slot_not_catered" },
		{ label: "Others Issue", value: "customer_others" },
	],
	tech_bugs: [
		{ label: "Order Sync", value: "order_sync" },
		{ label: "App Issue", value: "app_issue" },
		{ label: "Edit Profile", value: "edit_profile" },
		{ label: "Login Issues On Website", value: "login_issues_website" },
	],
	international_prescription: [
		{
			label: "International Prescription Request",
			value: "international_prescription_request",
		},
	],
	delivery_Issues: [
		{label: "Reattempt Request", value: "reattempt_request"},
		{label: "Initiate RTO", value: "initiate_rto"},
		{label: "Tracking link not updated", value: "tracking_link_Not_updated"},
		{label: "Incorrect Tracking Status", value: "wrong_tracking_status"},
		{label: "Amount Paid - Order not handed over", value: "amount_paid_no_order"},
	],
	other_category: [{ label: "Other Issues", value: "other_subcategory" }],
	delivery_related: [
		{ label: "Delivery Issues", value: "delivery_issues" },
		{ label: "Damaged Product", value: "damaged_product" },
	],
	prescription_related: [
		{ label: "Prescription Request", value: "prescription_request" },
	],
	escalation: [
		{
			label: "Client Escalation via Medrep call",
			value: "client_escalation_via_medrep_call",
		},
		{
			label: "Client Escalation via WABA",
			value: "client_escalation_via_waba",
		},
	],
	ivr_requests: [{ label: "Client Call missed", value: "client_call_missed" }],
};

export const categoryOptions = [
	{ label: "Order Related", value: "order_related" },
	{ label: "Medical Escalations", value: "medical_escalations" },
	{ label: "Tech Bugs", value: "tech_bugs" },
	{ label: "Payments", value: "payments" },
	{ label: "Customer Complaints", value: "customer_complaints" },
	{ label: "International Prescription", value: "international_prescription" },
	{ label: "Delivery Issues", value: "delivery_Issues"},
	{ label: "Other", value: "other_category" },
	{ label: "Delivery Related", value: "delivery_related" },
	{ label: "Prescription Related", value: "prescription_related" },
	{ label: "Escalation", value: "escalation" },
	{ label: "IVR Requests", value: "ivr_requests" },
];

export const categoryOptionsForCreateTicket = [
	{ label: "Order Related", value: "order_related" },
	{ label: "Medical Escalations", value: "medical_escalations" },
	{ label: "Tech Bugs", value: "tech_bugs" },
	{ label: "Payments", value: "payments" },
	{ label: "Customer Complaints", value: "customer_complaints" },
	{ label: "International Prescription", value: "international_prescription" },
	{ label: "Delivery Issues", value: "delivery_Issues"}
	// { label: "Other", value: "other_category" },
	// { label: "Delivery Related", value: "delivery_related" },
	// { label: "Prescription Related", value: "prescription_related" },
	// { label: "Escalation", value: "escalation" },
	// { label: "IVR Requests", value: "ivr_requests" },
];

export const priorityOptions = [
	{ label: "Low", value: "0" },
	{ label: "Medium", value: "1" },
	{ label: "High", value: "2" },
	{ label: "Urgent", value: "3" },
];

export const priorityOptionsTicketStats = [
	{ label: "Low", value: "Low" },
	{ label: "Medium", value: "Medium" },
	{ label: "High", value: "High" },
	{ label: "Urgent", value: "Urgent" },
];

export const statusOptions = [
	{ value: "2", label: "Open" },
	{ value: "3", label: "Pending" },
	{ value: "4", label: "Resolved" },
	{ value: "5", label: "Closed" },
];

export const statusOptionsTicketStats = [
	{ value: "Open", label: "Open" },
	{ value: "Pending", label: "Pending" },
	{ value: "Resolved", label: "Resolved" },
	{ value: "Closed", label: "Closed" },
];

export const categoryMap = {
	order_related: "Order Related",
	medical_escalations: "Medical Escalations",
	customer_complaints: "Customer Complaints",
	payments: "Payments",
	tech_bugs: "Tech Bugs",
	international_prescription: "International Prescription",
	other_category: "Other",
	delivery_related: "Delivery Related",
	prescription_related: "Prescription Related",
	escalation: "Escalation",
	ivr_requests: "IVR Requests",
	delivery_Issues: "Delivery Issues"
};

export const categoryMapCreateTicket = {
	order_related: "Order Related",
	medical_escalations: "Medical Escalations",
	customer_complaints: "Customer Complaints",
	payments: "Payments",
	tech_bugs: "Tech Bugs",
	international_prescription: "International Prescription",
	other_category: "Other",
	delivery_Issues: "Delivery Issues",
	// delivery_related: "Delivery Related",
	// prescription_related: "Prescription Related",
	// escalation: "Escalation",
	// ivr_requests: "IVR Requests",
};

export const subCategoryMapTicketStats = [
	{ label: 'Address or Phone Change', value: 'edit_order'},
	{ label: 'Order Cancellation', value: 'order_cancellation'},
	{ label: 'Reverse Pick up', value: 'reverse_pick_up'},
	{ label: 'Return Product', value: 'return_product'},
	{ label: 'Reattempt Product', value: 'reattempt_product'},
	{ label: 'Mismatch Product', value: 'mismatch_product'},
	{ label: 'Missing Product', value: 'missing_product'},
	{ label: 'Refund', value: 'refund'},
	{ label: 'Delivery Issues', value: 'delivery_issues'},
	{ label: 'Damaged Product', value: 'damaged_product'},
	{ label: 'Hairfall', value: 'hairfall_issue' },
	{ label: 'Constipation', value: 'constipation_issue' },
	{ label: 'Dandruff', value: 'dandruff_issue' },
	{ label: 'Health conditions', value: 'health_issue' },
	{ label: 'Boils', value: 'boils_issue' },
	{ label: 'Itching', value: 'itching_issue' },
	{ label: 'Product Reaction', value: 'product_reaction_issue' },
	{ label: 'Sexual issue', value: 'sexual_issue' },
	{ label: 'Gastric issues', value: 'gastric_issue' },
	{ label: 'Other Issue', value: 'other_issue' },
	{ label: 'Order Related Refunds', value: 'order_related_refunds' },
	{ label: 'Payments Issue', value: 'payments_issue' },
	{ label: '5 Months Money Back', value: 'five_month_money_back' },
	{ label: 'Coach Service', value: 'coach_service' },
	{ label: 'Angry Customer', value: 'angry_customer' },
	{ label: 'No Results with Traya', value: 'no_results_traya' },
	{ label: 'Negative Review', value: 'negative_review' },
	{ label: 'Order Sync', value: 'order_sync' },
	{ label: 'App Issue', value: 'app_issue' },
	{ label: 'Edit Profile', value: 'edit_profile' },
	{ label: 'Login Issues On Website', value: 'login_issues_website' },
	{ label: 'International Prescription Request', value: 'international_prescription_request'},
	{ label: 'Other Issue', value: 'other_subcategory' },
	{ label: "Reattempt Request", value: "reattempt_request"},
	{ label: "Initiate RTO", value: "initiate_rto"},
	{ label: "Tracking link not updated", value: "tracking_link_Not_updated"},
	{ label: "Incorrect Tracking Status", value: "wrong_tracking_status"},
	{ label: "Amount Paid - Order not handed over", value: "amount_paid_no_order"},
	{ label: "Payment failures/ No order placed", value: "payment_failure"},
	{ label: "Slot completely missed", value: "slot_missed"},
	{ label: "Slot not catered on time", value: "slot_not_catered"},
	{ label: "Others Issue", value: "customer_others"},
	{ label: "Referral Code", value: "referral_code"}
]

export const subCategoryMap = {
	tech_bugs: 'Tech Issues',
	order_sync: 'Order Sync',
	app_issue: 'App issue ',
	edit_profile: 'Edit profile',
	login_issues_website: 'Login Issue on website',
	medical_escalations: 'Medical Escalations',
	follow_up_medical: 'Follow Up Intervention',
	follow_up_call: 'Follow Up Call',
	hairfall_issue: 'Hairfall',
	constipation_issue: 'Constipation',
	dandruff_issue: 'Dandruff',
	health_issue: 'Health conditions',
	itching_issue: 'Itching',
	product_reaction_issue: 'Product Reaction ',
	sexual_issue: 'Sexual issue',
	gastric_issue: 'Gastric issues',
	other_issue: 'Other Medical Issues',
	order_related: 'Order Related Concerns',
	order_cancellation: 'Order Cancellation',
	reverse_pick_up: 'Reverse Pick Up',
	damaged_product: 'Damaged Product',
	missing_product: 'Missing Product ',
	mismatch_product: 'Mismatch Product',
	delivery_Issues: 'Delivery Issues',
	reattempt_request: 'Reattempt Request',
	initiate_rto: 'Initiate RTO',
	tracking_link_Not_updated: 'Tracking Link Not Updated',
	wrong_tracking_status: 'Incorrect Tracking Status',
	amount_paid_no_order: 'Amount Paid Order Not Handed Over',
	payments: 'Payment Issue',
	payments_issue: 'Payment Issue',
	order_related_refunds: 'Order Related Refunds',
	payment_failure: 'Payment Failure No Order Placed',
	referral_code: 'Referall Code',
	customer_complaints: 'Customer Complaints',
	five_month_money_back: 'Five month money back',
	coach_service: 'Coach service',
	angry_customer: 'Angry Customer',
	no_results_traya: 'No Result with Traya',
	negative_review: 'Negative Review ',
	slot_missed: 'Slot Completely Missed',
	slot_not_catered: 'Slot not Catered On Time',
	customer_others: 'Other Customer Issue',
	traya_general_enquiries: 'General Queries',
	i_want_to_understand_more_about_the_treatment: 'Doctor Related Enquiries',
	doctor_related_enquiries: 'I Want To Understand More About The Treatment',
	hair_test: 'Hair Test',
	'how_does_the_hair_test_work?': 'How does the hair test work?',
	i_am_facing_difficulty_in_filling_the_hair_test: 'I am facing difficulty in filling the hair test',
	hair_coach: 'Hair Coach',
	hair_coach_general_enquiries: 'Hair coach general enquiries',
	i_have_a_problem_with_my_appointment: 'I Want To Report A Concern Regarding My Appointment',
	diet_plan: 'Diet Plan',
	"i_want_to_know_more_about_traya's_diet_plan": "I Want To Know More About Traya's Diet Plan",
	i_have_a_query_regarding_my_diet_plan: 'I have a query regarding my diet plan',
	reward_coins: 'Reward Coins',
	i_want_to_understand_more_about_rewards: 'I want to understand more about rewards',
	i_have_an_issue_with_my_reward_coins: 'I have an issue with my reward coins',
	prescription: 'Prescription',
	i_have_an_issue_with_my_prescription: 'I have an issue with my prescription',
	my_treatment_results: 'My Treatment/Results',
	i_have_concerns_with_my_results_after_using_traya: 'I Want To Discuss The Progress On My Treatment',
	'moneyback_guarantee_&_refund_policy': 'Moneyback Guarantee',
	moneyback_guarantee: 'Moneyback Guarantee',
	'payments_&_refunds': 'Payments & Refunds',
	i_want_to_know_about_payment_options: 'I Want To Know About Payment Options',
	i_have_a_refund_related_query: 'I Have A Refund Related Query',
	i_have_an_issue_with_my_payment: 'I Have An Issue With My Payment',
	how_to_use: 'How To Use',
	i_want_to_understand_usage_of_products_in_my_kit: 'I Want To Understand Usage Of Products In My Kit',
	other_queries_regarding_usage: 'Other Queries Regarding Usage',
	reorder_queries: "Next Month's Plan",
	i_have_a_query_regarding_reorder: 'I Have A Query Regarding Reorder',
	no_results_with_traya: 'No Results With Traya',
	return_request: 'Return Request',
	medical_document: 'Medical Document',
	referall_code: 'Referral Code',
	product_related_quality_issues: 'Product Related Quality Issues',
	hair_ras: 'Hair Ras',
	health_tatva: 'Health Tatva',
	scalp_oil_booster_oils: 'Scalp Oil / Booster Oils',
	gutt_shuddhi: 'Gutt Shuddhi',
	nasal_grit: 'Nasal Grit',
	digest_boost: 'Digest Boost',
	consti_clear: 'Consti Clear',
	cholest_vati: 'Cholest Vati',
	pcos_santulan: 'PCOS Santulan',
	thyro_santulan: 'Thyro Santulan',
	her_santulan: 'Her Santulan',
	mom_santulan: 'Mom Santulan',
	'minoxidil_2%': 'Minoxidil 2%',
	'minoxidil_5%': 'Minoxidil 5%',
	anti_dandruff_shampoo: 'Anti-Dandruff Shampoo',
	anti_dandruff_night_lotion: 'Anti-Dandruff Night Lotion',
	defence_shampoo: 'Defence Shampoo',
	recap_serum: 'Recap Serum',
	hair_vitamin: 'Hair Vitamin',
	cuticle_damage_range: 'Cuticle Damage Range',
	nourish_hair_oil_: 'Nourish Hair Oil ',
	new_product_suggestion: 'New Product Suggestion',
	swelling_issue: 'Swelling Issue',
	boils_issue: 'Boils Issue',
	'i_have_a_problem_with_my_existing_order(s)': 'I Have A Problem With My Existing Order(s)',
	auto_order_cancellation_initiated: 'Auto Order Cancellation Initiated',
	doctor_call: 'Doctor Call',
	case_deterioration: 'Case Deterioration',
	testing_subcate_prod: 'Testing Subcate Prod',
	auto_prepaid_rto: 'Auto Prepaid RTO',
	test_subcat: 'Test Subcat',
	amount_paid_to_the_delivery_partner_but_order_not_delivered: 'Amount Paid To The Delivery Partner But Order Not Delivered',
	five_months_no_results: 'Five Months No Results',
	deterioration: 'Deterioration',
	non_alcohol_minoxidil_concerns: 'Non Alcohol Minoxidil Concerns',
};

export const priorityMap = {
	Low: "0",
	Medium: "1",
	High: "2",
	Urgent: "4",
};

export const getAssignesList = async (
	orderId,
	category,
	subCategory,
	doctorsList,
	ticketId,
	status = "creating"
) => {
	let assigned = [];
	let settingKey = `${category}_${subCategory}`
	const loggedInUser = secureLocalStorage.getItem("users");
	// const isSupervisor = secureLocalStorage.getItem('is!supervisor');
	if (
		(category === "order_related" && subCategory === "order_cancellation") ||
		(category === "order_related" && subCategory === "mismatch_product") ||
		(category === "order_related" && subCategory === "missing_product") ||
		(category === "order_related" && subCategory === "reverse_pick_up") ||
		(category === "order_related" && subCategory === "reattempt_product") ||
		(category === "order_related" && subCategory === "return_product") ||
		(category === "order_related" && subCategory === "edit_order") ||
		(category === "order_related" && subCategory === "damaged_product") ||
		(category === "medical_escalations" && subCategory === "hairfall_issue") ||
		(category === "medical_escalations" && subCategory === "dandruff_issue") ||
		(category === "medical_escalations" && subCategory === "constipation_issue") ||
		(category === "medical_escalations" && subCategory === "health_issue") ||
		(category === "medical_escalations" && subCategory === "boils_issue") ||
		(category === "medical_escalations" && subCategory === "itching_issue") ||
		(category === "medical_escalations" && subCategory === "product_reaction_issue") ||
		(category === "medical_escalations" && subCategory === "sexual_issue") ||
		(category === "medical_escalations" && subCategory === "gastric_issue") ||
		(category === "medical_escalations" && subCategory === "other_issue") ||
		(category === "customer_complaints" && subCategory === "five_month_money_back") ||
		(category === "customer_complaints" && subCategory === "coach_service") ||
		(category === "customer_complaints" && subCategory === "angry_customer") ||
		(category === "customer_complaints" && subCategory === "no_results_traya") ||
		(category === "customer_complaints" && subCategory === "negative_review") ||
		(category === "customer_complaints" && subCategory === "slot_missed") ||
		(category === "customer_complaints" && subCategory === "slot_not_catered") ||
		(category === "customer_complaints" && subCategory === "customer_others") ||

		(category === "tech_bugs" && subCategory === "order_sync") ||
		(category === "tech_bugs" && subCategory === "app_issue") ||
		(category === "tech_bugs" && subCategory === "edit_profile") ||
		(category === "tech_bugs" && subCategory === "login_issues_website") ||
		(category === "payments" && subCategory === "order_related_refunds") ||
		(category === "payments" && subCategory === "payment_failure") ||
		(category === "payments" && subCategory === "payments_issue") ||
		(category === "payments" && subCategory === "referral_code") ||
		(category === "international_prescription" && subCategory === "international_prescription_request") ||
		(category === "other_category" && subCategory === "other_subcategory") ||
		(category === "delivery_Issues" && subCategory === "reattempt_request") ||
		(category === "delivery_Issues" && subCategory === "initiate_rto") ||
		(category === "delivery_Issues" && subCategory === "tracking_link_Not_updated") ||
		(category === "delivery_Issues" && subCategory === "wrong_tracking_status") ||
		(category === "delivery_Issues" && subCategory === "amount_paid_no_order")
	) {
		let newAssign = await fetchAssigne(settingKey);
		if (
			!newAssign ||
			!Array.isArray(newAssign) ||
			newAssign.some(obj => obj.label === null || obj.Value === null)
		) {
			assigned = assignToOptions[category][subCategory];
		} else {
			assigned = newAssign;
		}
	}
	else {
		const res = await getAssignedPersons(orderId, category, subCategory);
		if (res && res.data && res.data[0]) {
			const assignes = res.data || [];
			assignes.forEach(doc =>
				assigned.push({ value: doc.id, label: doc.first_name })
			);
		}
	}
	if (status === "updating") {
		const res = await getPreviouselyAssignedPersons(ticketId);
		if (res && res.data) {
			res.data.forEach(doc =>
				assigned.push({ value: doc.id, label: doc.first_name })
			);
		}
	}
	if (status === "updating" && category !== "medical_escalations") {
		const _ops = [];
		Object.values(opsTeamMember).forEach(item => _ops.push({ ...item }));
		assigned = [...assigned, ..._ops];
	}

	if (
		category === "medical_escalations" &&
		(loggedInUser ===
			escalationTeamMember["priyankakanojia@traya.health"].value ||
			loggedInUser === escalationTeamMember["khanmahenaaz@traya.health"].value)
	) {
		const _assigned = [];
		_assigned.push(escalationTeamMember["siddhi@tatva.health"]);
		_assigned.push(escalationTeamMember["kalyani@tatva.health"]);
		_assigned.push(escalationTeamMember["harish@traya.health"]);
		_assigned.push(escalationTeamMember["shefali@tatva.health"]);
		assigned = _assigned;
	}

	assigned = assigned.filter(item => item.value !== loggedInUser);
	assigned = [...new Map(assigned.map(item => [item["value"], item])).values()]; // unique values
	return assigned;
};

export const getAssigneesForIvr = (ticketInfo, doctorList) => {
	const assignees = [];
	// const isSupervisor = secureLocalStorage.getItem('is!supervisor');
	// if (getCurrentUserRole() === 'admin' || isSupervisor === 'true') {
	// 	if (doctorList && doctorList.length > 0) {
	// 		doctorList.forEach(doc => {
	// 			if (doc && doc.user && doc.user.first_name)
	// 				assignees.push({ value: doc.user_id, label: doc.user.first_name });
	// 		});
	// 	}
	// }
	assignees.push({
		value: ticketInfo.current_assignment?.user_id,
		label: ticketInfo.current_assignment?.first_name,
	});
	return assignees;
};

export const formatTicketData = (data, startDate, endDate) => {
	if (!Array.isArray(data) || data.length === 0) return;
	let tickets = [];

	tickets = data

	return tickets.map(item => ({
		key: getValue(item, "_id"),
		case_id: getValue(item, "case_id"),
		created_at: moment(getValue(item, "createdAt")).format(
			"DD MMM YYYY, h:mm a"
		),
		updated_at: moment(getValue(item, "updatedAt")).format(
			"DD MMM YYYY, h:mm a"
		),
		description: getValue(item, "description"),
		status: getValue(item, "status"),
		category: getValue(item, "category"),
		sub_category: getValue(item, "sub_category"),
		priority: getValue(item, "priority"),
		ticket_id: getValue(item, "provider_meta.ref_id"),
		images: getValue(item, "images"),
		customer: {
			...getValue(item, "customer"),
			case_id: getValue(item, "case_id"),
		},
		comments: getValue(item, "comments"),
		latestComment: getValue(item, "comments[0].description"),
		history: getValue(item, "history"),
		current_assignment: getValue(item, "current_assignment"),
		author: getValue(item, "author"),
		source_meta: getValue(item, "source_meta"),
		status_code: getValue(item, "status_code"),
		priority_code: getValue(item, "priority_code"),
		provider_meta: getValue(item, "provider_meta"),
		due_date: getValue(item, "due_date"),
		firstComment: getValue(item, "provider_meta.description"),
		order_display_id: getValue(item, "source_meta.order_display_id"),
	}));
};

export const subCategoryMapping = {
	TICKET_ORDER_MISSING_OR_DAMAGED_ITEM: 'damaged_product',
	TICKET_ORDER_MISMATCH_PRODUCT: 'mismatch_product',
	TICKET_ORDER_MISSING_PRODUCT: 'missing_product',
	TICKET_ORDER_CANCEL_ORDER: 'order_cancellation',
	TICKET_ORDER_REVERSE_PICKUP: 'reverse_pick_up',
	TICKET_ORDER_RETURN_PRODUCT: 'return_product',
	TICKET_ORDER_REATTEMPT_PRODUCT: 'reattempt_product',
	TICKET_ORDER_ADD_PHONE_CHANGE: 'edit_order',
	TICKET_MEDICAL_ESCALATIONS_HAIRFALL: 'hairfall_issue',
	TICKET_MEDICAL_ESCALATIONS_CONSTIPATION: 'constipation_issue',
	TICKET_MEDICAL_ESCALATIONS_DANDRUFF: 'dandruff_issue',
	TICKET_MEDICAL_ESCALATIONS_HEALTH: 'health_issue',
	TICKET_MEDICAL_ESCALATIONS_BOILS: 'boils_issue',
	TICKET_MEDICAL_ESCALATIONS_ITCHING: 'itching_issue',
	TICKET_MEDICAL_ESCALATIONS_PRODUCT_REACTION: 'product_reaction_issue',
	TICKET_MEDICAL_ESCALATIONS_SEXUAL_ISSUE: 'sexual_issue',
	TICKET_MEDICAL_ESCALATIONS_GASTRIC_ISSUE: 'gastric_issue',
	TICKET_MEDICAL_ESCALATIONS_OTHER: 'other_issue',
	TICKET_PAYMENTS_REFUND: 'order_related_refunds',
	TICKET_PAYMENTS_PAYMENT_ISSUE: 'payments_issue',
	TICKET_PAYMENTS_PAYMENT_FAILURE_NO_ORDER_PLACED: 'payment_failure',
	TICKET_PAYMENTS_REFERRAL_CODE: 'referral_code',
	TICKET_CUSTOMER_COMPLAINT_FIVE_MONTH_MONEY: 'five_month_money_back',
	TICKET_CUSTOMER_COMPLAINT_COACH_SERVICE: 'coach_service',
	TICKET_CUSTOMER_COMPLAINT_ANGRY_CUSTOMER: 'angry_customer',
	TICKET_CUSTOMER_COMPLAINT_NO_RESULT_TRAYA: 'no_results_traya',
	TICKET_CUSTOMER_COMPLAINT_NEGATIVE_REVIEW: 'negative_review',
	TICKET_CUSTOMER_COMPLAINT_SLOT_MISSED: 'slot_missed',
	TICKET_CUSTOMER_COMPLAINT_SLOT_NOT_CATERED: 'slot_not_catered',
	TICKET_CUSTOMER_COMPLAINT_CUSTOMER_OTHER: 'customer_others',
	TICKET_TECH_BUGS_ORDER_SYNC: 'order_sync',
	TICKET_TECH_BUGS_APP_ISSUE: 'app_issue',
	TICKET_TECH_BUGS_EDIT_PROFILE: 'edit_profile',
	TICKET_TECH_BUGS_LOGIN_ISSUES: 'login_issues_website',
	TICKET_INTERNATIONAL_PRESCRIPTION_REQUEST:
		'international_prescription_request',
	TICKET_DELIVERY_ISSUES_REATTEMPT_REQUEST: 'reattempt_request',
	TICKET_DELIVERY_ISSUES_INITIATE_RTO: 'initiate_rto',
	TICKET_DELIVERY_ISSUES_TRACKING_LINK_NOT_UPDATED: 'tracking_link_Not_updated',
	TICKET_DELIVERY_ISSUES_INCORRECT_TRACKING_STATUS: 'wrong_tracking_status',
	TICKET_DELIVERY_ISSUES_AMOUNT_PAID_ORDER_NOT_HANDED_OVER: 'amount_paid_no_order',
};

export const isComplaintTeam = () =>{
	const role = getCurrentUserRole();
  	const currentUserLevel = secureLocalStorage.getItem('level');
	const isLevel2Admin = role === ROLES_NAME.ADMIN && currentUserLevel === 2;
	const isSuperAdmin = role === ROLES_NAME.SUPER_ADMIN;
	return isSuperAdmin || isLevel2Admin;
}